export const featuredProjectCount = 4;

export const projects = [
  {
    name: "SprintSpark",
    featured: true,
    category: "developer tools",
    description: "a full-stack developer productivity platform that turns engineering activity and meeting content into useful project knowledge.",
    longDescription: "SprintSpark brings together developer workflows across tools such as GitHub, Jira, and Confluence, with AI-powered features for meeting transcription, summarization, structured documentation, and project insights.",
    technologies: ["Django", "React", "TypeScript", "Docker", "REST APIs", "LLMs", "GitHub API", "Jira API", "Confluence API"],
    githubUrl: "https://github.com/eshaanganesh2/Integrated-SDLC-Automation-Validation-Engine",
    demoUrl: null,
  },
  {
    name: "TikTalk",
    featured: true,
    category: "ai · social",
    description: "an ai-powered multi-user chat experience where users can interact with different conversational personalities.",
    longDescription: "built backend logic for varied ai conversational personas using LangChain, alongside a multi-user chat interface, automated testing, Docker, and CI/CD workflows.",
    technologies: ["Flask", "JavaScript", "LangChain", "Docker", "GitHub Actions", "CI/CD"],
    githubUrl: "https://github.com/zeepxnflrp/TikTalk",
    demoUrl: null,
  },
  {
    name: "Sing & Sync",
    featured: true,
    category: "music technology",
    description: "a music-processing application that analyzes audio and converts musical information into structured digital output.",
    longDescription: "implemented backend features for note-onset detection, tempo estimation, and music signal processing, alongside CRUD functionality, AWS S3 media storage, automated testing, and ML-powered audio-to-MIDI conversion.",
    technologies: ["Flask", "Python", "AWS S3", "Docker", "Audio Processing", "Unit Testing", "CI/CD"],
    githubUrl: "https://github.com/zeepxnflrp/Sing-Sync",
    demoUrl: null,
  },
  {
    name: "Pew Pew Panic",
    featured: true,
    category: "game",
    description: "a minimalist one-button arcade game built around movement, hazards, timing, and increasingly chaotic game feel.",
    longDescription: "built in Unity with automatic horizontal movement and shooting, one-button vertical control, persistent high scores, UI/game states, sound design, enemy collisions, and hazards including temporary gravity reversal and floor-is-lava sequences.",
    technologies: ["Unity", "C#", "Game Design", "Gameplay Systems"],
    githubUrl: "https://github.com/zeepxnflrp/minimalist-game",
    demoUrl: "https://zeepyx.itch.io/pew-pew-panic",
  },
  {
    name: "CaptionNet",
    featured: false,
    category: "computer vision · nlp",
    description: "built an image caption generator using cnn feature extraction and rnn/lstm caption modeling.",
    longDescription: "designed data preprocessing, trained the model on MNIST variants, and evaluated caption accuracy and performance.",
    technologies: ["PyTorch", "Neural Networks (CNNs & RNNs)", "Natural Language Processing (NLP)"],
    githubUrl: null,
    demoUrl: null,
    githubNeeded: true,
  },
  {
    name: "ArtRoam",
    featured: false,
    category: "creative tools",
    description: "a web application that empowers artists with a vibrant, interactive canvas for creative expression.",
    technologies: [],
    githubUrl: "https://github.com/zeepxnflrp/ArtRoam",
    demoUrl: null,
  },
  {
    name: "django-cv",
    featured: false,
    category: "web",
    description: "small class project to convert cv to html using django",
    technologies: [],
    githubUrl: "https://github.com/zeepxnflrp/django-cv",
    demoUrl: null,
  },
  {
    name: "PyRizz",
    featured: false,
    category: "python",
    description: "a Python package that provides a collection of randomly generated pickup lines in various categories.",
    technologies: ["Python"],
    githubUrl: "https://github.com/zeepxnflrp/PyRizz",
    demoUrl: null,
  },
  {
    name: "website-v1",
    featured: false,
    category: "web",
    description: "work in progress personal website using TypeScript, Next.js, and Tailwind CSS.",
    technologies: ["TypeScript", "Next.js", "Tailwind CSS"],
    githubUrl: "https://github.com/zeepxnflrp/website-v1",
    demoUrl: null,
  },
];
